import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
   DevicesTab,
   PageHeader,
   PageTitle,
   Wrapper,
   useVendoData,
} from '@/pages/Admin/Vendo';
import { colors } from '@/constants/colors';
import { useUIStore } from '@/store/useUIStore';

const WifiDevices = () => {
   useVendoData({ sessions: false });
   const navigate = useNavigate();
   const handleShow = useUIStore((s) => s.handleShow);
   return (
      <Wrapper>
         <HeaderRow>
            <PageHeader>
               <PageTitle>Devices</PageTitle>
            </PageHeader>
            <HeaderActions>
               <ClaimLinkBtn
                  onClick={() =>
                     handleShow({
                        template: 'claim-device',
                        title: 'Claim a transfer',
                        data: null,
                     })
                  }
               >
                  🔑 Claim a transfer
               </ClaimLinkBtn>
               <SoldLinkBtn onClick={() => navigate('/wifi-sold-device')}>
                  View sold devices →
               </SoldLinkBtn>
            </HeaderActions>
         </HeaderRow>
         <DevicesTab />
      </Wrapper>
   );
};

export default WifiDevices;

const HeaderActions = styled.div`
   display: flex;
   gap: 8px;
`;

const HeaderRow = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 12px;
   margin-bottom: 8px;
`;

const SoldLinkBtn = styled.button`
   background: transparent;
   color: ${colors.PRIMARY};
   border: 1px solid ${colors.PRIMARY}40;
   border-radius: 8px;
   padding: 8px 14px;
   font-size: 12px;
   font-weight: 700;
   cursor: pointer;
   white-space: nowrap;
   &:hover {
      background: ${colors.PRIMARY}10;
   }
`;

const ClaimLinkBtn = styled.button`
   background: ${colors.PRIMARY};
   color: ${colors.WHITE};
   border: none;
   border-radius: 8px;
   padding: 8px 14px;
   font-size: 12px;
   font-weight: 700;
   cursor: pointer;
   white-space: nowrap;
   &:hover {
      opacity: 0.9;
   }
`;
